import * as dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekday);

/**
 * 格式化日期，默认精确到分钟
 * @param {String} date 日期
 * @param {String} format 格式化
 * @param {String} format 当前时区-取org settings设置的时区
 */
export const formatTime = (date, format = '', userTimezone = 'America/New_York') => {
  if (!date) {
    return '';
  }
  const formatStr = format || 'MMM DD, YYYY hh:mm a';
  return dayjs(date).utc(true).tz(userTimezone).format(formatStr);
};

// 获取纽约时间
export const getNewYorkDate = (date) => dayjs.utc(date).tz('America/New_York');

// 判断是否为周末
export const isWeekend = (date) => [0, 6].includes(getNewYorkDate(date).get('day'));

// 获取下一个weekday
export const getNextWeekday = (date) => {
  const newYorkDate = getNewYorkDate(date).add(1, 'day');
  if (!isWeekend(newYorkDate)) {
    return newYorkDate;
  }
  return newYorkDate.get('day') === 0 ? newYorkDate.add(1, 'day') : newYorkDate.add(2, 'day');
};

// 获取纽约时区 UTC-04:00 /UTC-05:00
export const getTimezoneOffset = (date) => {
  const offset = getNewYorkDate(date).utcOffset() / 60;
  return `UTC-0${0 - offset}:00`;
};
